/**
 * Loading fallback component for React.lazy() code-split pages
 * Displays a minimal loading indicator while page chunks are being fetched
 *
 * Story 24.7b — `fullViewport` (`min-h-dvh`) is for the top-level Suspense in
 * `App.tsx`, which renders before any layout. Everywhere else the fallback
 * sits inside MainLayout's bounded `<main>` and fills it (`min-h-full`).
 */
export default function PageLoadingFallback({ fullViewport = false }: { fullViewport?: boolean } = {}) {
  return (
    <div
      className={`flex ${fullViewport ? 'min-h-dvh' : 'min-h-full'} items-center justify-center bg-canvas`}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-active-wash border-t-action" />
        <p className="text-sm text-ink-muted">Loading...</p>
      </div>
    </div>
  );
}
